import React from "react";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ConstructionTypeViewController, ConstructionTypeViewControllerDelegate } from "../../Screen/ConstructionType/ConstructionTypeViewController";
import { ConstructionTypeViewModel } from "../../Screen/ConstructionType/ConstructionTypeViewModel";
import { TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import ProtectedRoute from "../../Components/ProtectedRoute";


export class ConstructionTypeCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, ConstructionTypeViewControllerDelegate {
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipoconstrucao")
        return (<ProtectedRoute requiredPermissions={['prop.tipo_construcao.*']} path="/:base/tipo-construcao" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.tipo_construcao.adicionar',
                    edit: 'prop.tipo_construcao.editar',
                    delete: 'prop.tipo_construcao.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Tipo Construção"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new ConstructionTypeViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.tipo_construcao.adicionar', 'prop.tipo_construcao.editar']} path="/:base/tipo-construcao/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ConstructionTypeViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipoconstrucao") {
            navigation.history.push(`tipo-construcao/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipoconstrucao") {
            navigation.history.push(`tipo-construcao/cad/${idSelection}`);
            return;
        }
    }

}
